import React from 'react'

const ModalRoot = () => <div id="modal-root" />

export default ModalRoot
